import AddIcon from 'components/ReusableComponents/Icons/Add'
import RemoveIcon from 'components/ReusableComponents/Icons/Remove'
import PropTypes from 'prop-types'

import styles from './RateCodeControl.module.scss'

const actions = {
  add: 'add',
  remove: 'remove'
}

const RateCodeControl = ({ action = actions.add, onClick, count }) => (
  <div
    className={action === actions.add ? styles.wrapperAdd : styles.wrapperRemove}
    onClick={onClick}
  >
    <div className={styles.container}>
      <div className={styles.actionIcon}>
        {action === actions.add && <AddIcon width={28} height={28} fill="#4079F5" />}
        {action === actions.remove && (
          <RemoveIcon width={28} height={28} fill="#F56B6B" />
        )}
      </div>
      {action === actions.add && (
        <span className={styles.rateCode}>Add all {count} codes</span>
      )}
      {action === actions.remove && (
        <span className={styles.rateCode}>Remove all selected codes</span>
      )}
    </div>
  </div>
)

RateCodeControl.propTypes = {
  action: PropTypes.oneOf(Object.values(actions)),
  count: PropTypes.number,
  onClick: PropTypes.func
}

export default RateCodeControl
